module.exports = __webpack_public_path__ + "img/pc.7d8c8acc.webp";